import styled from "styled-components";

export const BannerDetailContainerStyled = styled.div``;
